import api from '../../api/api.js'
import userStoreItems from '../../api/moudles/userStoreItems.js'

import { Message } from 'element-ui'

import {

  GET_USER_STORE_LIST,
  SET_ITEMS_COUNT,
  SET_BIND_ITEMS_LIST,
  REMOVE_ITEM,
  REMOVE_BIND_ITEM,
  TARGET_ALL,
  GET_DATA_STATUS,
  GET_DATA_STATUS_COLSE,
  SET_REPLENISHMENT_PREIOD,
  GET_QUENTITY_OUT_OF_STOCK,
  SET_SUCCESS_ERROR_NULL,
  SET_COUNT_QUEHUO,
  GET_QUENTITY_OUT_OF_STOCK_01,
  KEEP_CHOOSED_ITEM,
  GET_UNSALABLE_DATA
  

} from '../mutation-types'
import { reject, resolve } from 'core-js/fn/promise'
import promise from 'core-js/fn/promise'

const state = () => ({
	userStormList:[],
	itemsCount:0,
	bindItemList01:[],
	deleTip:0,
	deletSuccess:'',
	getDateSuccess:false,
	xuehuoInfo:[],
	xuehuoInfo01:[],
	xuehuoInfocount:0,
	storeSalesInfo:[],
	storeproductinventoryturnover:0,
	storeoperaterecord:[],
	storeoperaterecordcount:0,
	ischooselist:[],
	newUserstoreItem:[],
	refresh:false,
	tableList:[],
	tableCount:0,
	bindInfoList:[],
	openAutoPre:false,
	closeAutoPre:false,
	jieSuceess:false,
	bindSuceess:0,
	targetlist:[],
	slugInReminder:[],
	unsalable:[]
	
	
})

const getters = {}

const actions = {
	getRuler({state,commit},payload) {
		const p=new Promise((resolve) => {
			userStoreItems
			.getRuler(payload)
			.then(res => {
				if(res.code === 200) {
					resolve(res.data)
				}
			})
		})

		return p
	},
	
	updateStoreNumBystore({state,commit},payload) {
		const p =new Promise((resolve) => {
			userStoreItems
			.updateStoreNumBystore(payload)
			.then(res => {
				if(res.code === 200) {
					Message({
						message: '库存更新成功！',
						type: 'success'
					})
					resolve('200')
				}else{
					Message({
						message: res.msg,
						type: 'error'
					})
				}
			})

		})

		return p
	},
	//绑定商品
	bindItem ({state,commit},payload) {
		userStoreItems
		.bindItem(payload)
		.then(res => {
			if(res.code === 200) {
				Message({
					message: '绑定成功！',
					type: 'success'
				})
			}else{
				Message({
					message: res.msg,
					type: 'error'
				})
			}
		})
		
		
	},
	//查看绑定情况 -- GROUPID
	viewBindInfo({state,commit},payload) {
		userStoreItems
		.viewBindInfo(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('skuname',res.data)
				state.bindInfoList=res.data
				state.bindInfoList.forEach(p => {
					p.active=false
					if(p.variations !== null){
						p.variations.forEach(k => {
							if(k.cusCode > 0) {
								k.bound=k.storeItem.skuName === "" ?  k.storeItem.variationName : k.storeItem.skuName 
							}else{
								k.bound=this.$t("other.a140")
							}
						})
					}
				
				})
				console.log('查看绑定情况',state.bindInfoList)
			}
		})
	},
	//获取仓库绑定列表的增加按钮的信息
	getTableList({state,commit},payload) {
		
		userStoreItems
		.getStoreItemBystore(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('仓库帐号仓库产品的item',res.data)
				state.tableList=res.data.items
				state.tableCount=res.data.count
				
			}
		})
	},
	//修改绑定库存产品
	updateBindStoreItem({state},payload) {
		userStoreItems
		.updateBindStoreItem(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('修改绑定库存产品',res.data)
				Message({
					message: '保存成功！',
					type: 'success'
				})
			}else{
				Message({
					message: res.msg,
					type: 'error'
				})
			}
		})
	},
	
	//更新是否自动开启预售
	updateIsAutoPre({state},payload) {
		userStoreItems
		.updateIsAutoPre(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('更新是否自动开启预售',res.data)
				Message({
					message: '预售天数修改成功！',
					type: 'success'
				})
			}
		})
	},
	
	//修改母SKU
	updateGroup({state},payload) {
		userStoreItems
		.updateGroup(payload)
		.then(res => {
			if(res.code === 200) {
				Message({
					message: '更新成功',
					type: 'success'
				})
				
			}else{
				Message({
					message: res.msg,
					type: 'warning'
				})
			}
		})
	},
	
	deleteGroup({state},payload) {
		userStoreItems
		.deleteGroup(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('删除级别信息',res.data)
				Message({
					message: '成功删除',
					type: 'success'
				})
				state.refresh=true
				setTimeout(() => {
					state.refresh=false
				},500)	
			}
		})
	},
	
	updatRate({state},payload) {
		userStoreItems
		.updatRate(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('修改倍率',res.data)
				Message({
					message: '倍率修改成功',
					type: 'success'
				})
				
			}
		})
	},
	
	fileUpload({state},payload) {
		userStoreItems
		.fileUpload(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('文件上传',res.data)
				
			}
		})
	},
	//获取仓库的库存操作日志
	getInstockoperaterecore({state},payload) {
		userStoreItems
		.getInstockoperaterecore(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('仓库库存操作日志',res.data)
				// state.storeoperaterecord=res.data.logs
				state.storeoperaterecord=res.data.logList
				state.storeoperaterecordcount=res.data.count
			}
		})
	},
	
	//获取仓库的库存周转率
	getStoreProductInventoryTurnover({state},payload) {
		userStoreItems
		.getStoreProductInventoryTurnover(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('仓库库存周转率',res.data)
				state.storeproductinventoryturnover=res.data.toFixed(2)
			}
		})
	},
	//获取仓库产品的销售情况 
	getStoreSales({state},payload) {
		userStoreItems
		.getStoreSales(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('仓库产品的销售情况',res.data)
				state.storeSalesInfo=res.data
			}
		})
	},
	
	//是否自动开启预售
	isAutoPre({state,commit},payload) {
		userStoreItems
		.isAutoPre(payload)
		.then(res => {
			if(res.code === 200) {
				if(payload.isAutoPre){
					Message({
						message: '已开启自动预售模式',
						type: 'success'
					})
					state.openAutoPre=true
					setTimeout(() => {
						state.openAutoPre=false
					})
				}else{
					Message({
						message: '已关闭自动预售模式',
						type: 'success'
					})
					state.closeAutoPre=true
					setTimeout(() => {
						state.closeAutoPre=false
					})
				}
				
			}
		})
	},
	//仓库获取用户仓库物品销售
	getStoreItemBystore({commit},payload) {
		userStoreItems
		.getStoreItemBystore(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('仓库帐号仓库产品的item',res.data)
				res.data.items.forEach(p => {
					p.checked=false
					p.items.forEach(k => {
						k.setRate=false
					})
				})
				commit(GET_USER_STORE_LIST,res.data)
				// dispatch('getStoreItemCount',payload)
			}
		})
	},
	 //卖家获取用户仓库物品信息
	getStoreItem({commit},payload) {
		let p= new Promise((resolve) => {
			userStoreItems
			.getStoreItem(payload)
			.then(res => {
				if(res.code === 200) {
					console.log('仓库产品的item',res.data)
					commit(GET_USER_STORE_LIST,res.data)
					// dispatch('getStoreItemCount',payload)
					resolve(res.data)
				}
			})
		})

		return p
		
	},
	 //获取用户仓库下商品的总数
	getStoreItemCount({commit},payload) {
		userStoreItems
		.getStoreItemCount(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('本仓库下商品总数',res.data)
				// commit(SET_ITEMS_COUNT,res.data)
			}
		})
	},
	//创建采购单 
	createCaiGouTable({commit},payload) {
		userStoreItems
		.createCaiGouTable(payload)
		.then(res => {
			if(res.code === 200) {
				console.log('成功创建采购单',res.data)
				// commit(SET_ITEMS_COUNT,res.data)
			}
		})
	},
	//查看绑定商品
	viewBindItems({commit},payload) {
		userStoreItems
		.getStoreItem(payload) 
		.then(res => {
			if(res.code === 200) {
				console.log('查看绑定的商品',res.data)
				commit(SET_BIND_ITEMS_LIST,res.data.items[0].items)
			}
		})
	},
	//删除用户仓库物品信息
	deleStoreItems({commit},payload) {
		const p =new Promise((resolve,reject) => {
			userStoreItems
			.deleStoreItems(payload) 
			.then(res => {
				resolve(res)
			})
		})
		return p
		
	},
	//解绑已绑定的商品
	jiebanItems({state,commit},payload) {
		const p=new promise((resolve) => {
			userStoreItems
			.jiebanItems(payload) 
			.then(res => {
				resolve(res)
				if(res.code === 200) {
					
					// state.jieSuceess=true
					// Message({
					// 	message: '解绑成功',
					// 	type: 'success'
					// })
					
					// setTimeout(() => {
					// 	state.jieSuceess=false
					// })
					
				}
			})
		})

		return p
		
	},
	//更新仓库物品信息
	// updateItemInfo({commit},payload) {
	// 	userStoreItems
	// 	.updateItemInfo(payload) 
	// 	.then(res => {
	// 		if(res.code === 200) {
	// 			commit(GET_DATA_STATUS)
				
	// 		}
	// 	})
	// },
	 //同步更新
	updateStoreItem({commit},payload) {
		userStoreItems
		.updateStoreItem(payload) 
		.then(res => {
			if(res.code === 200) {
				alert("更新成功，请刷新页面！")
			}
		})
	},
	
	//更新当前库存数量到shopee
	updateShopeeItemStock({commit},payload) {
		userStoreItems
		.updateShopeeItemStock(payload) 
		.then(res => {
			if(res.code === 200) {
				alert("成功更新当前库存数量到shopee")
				console.log('更新shoppe库存',res.data)
				
			}
		})
	},
	
	//卖家用户更新仓库商品基本信息
	sellerUpdateStoreItemDetail({commit},payload) {

		return new Promise((resolve) => {
			userStoreItems
			.sellerUpdateStoreItemDetail(payload) 
			.then(res => {
				resolve(res)
				if(res.code === 200) {
					console.log("修改成功")
				}
			})
		})
	},

	sellerUpdateStoreItem({commit},payload) {
		return new Promise((resolve) => {
			userStoreItems
			.sellerUpdateStoreItem(payload) 
			.then(res => {
				resolve(res)
				if(res.code === 200) {
					console.log("修改成功")
				}
			})
		})
	},
	
	 //卖家用户开启或者关闭自动更新
	sellerUpdateSynchrony({commit},payload) {
		const p =new promise((resolve) => {
			userStoreItems
			.sellerUpdateSynchrony(payload) 
			.then(res => {
				resolve(res)
				// if(res.code === 200) {
				// 	commit(GET_DATA_STATUS)
				// }
			})
		})

		return p
		
	},
	
	//仓储用户更新仓库商品的在仓库存与仓位
	storeUpdateStoreNumAndAddress({commit},payload) {
		userStoreItems
		.storeUpdateStoreNumAndAddress(payload) 
		.then(res => {
			if(res.code === 200) {
				Message({
					message: '商品更新成功！',
					type: 'success'
				})
			}else {
				Message({
					message: '商品更新失败！',
					type: 'error'
				})
			}
		})
	},
	//获取缺货提醒
	getStockRemind({commit},payload) {
		const p=new Promise((resolve) => {
			console.log(payload.storeId)
			userStoreItems
			.getStockRemind(payload) 
			.then(res => {
				if(res.code === 200) {
					console.log('缺货提醒',res.data)
					// commit(GET_QUENTITY_OUT_OF_STOCK,{remindData:res.data,storeId:payload.storeId})
					resolve(res)
				}
			})
		})

		return p
	},

}

const mutations = {
	[GET_USER_STORE_LIST]: (state,data) =>{
		data.groups.forEach(p => {
			p.checked=false
			p.checked01=false
			p.checked02=true
			p.checked03=false
			p.qytInStore=0
			if(p.storeItems){
				p.storeItems.forEach(k => {
					k.checked_one=false
					k.reservedStockCopy=0
					k.reservedStockTotal=0
					k.assibleUnshiped=0
					p.qytInStore += Number(k.storeNum)
					k.checked=false
					k.items.forEach(i => {
						i.setPresale=false
						i.setRate=false
					})
					k.reservedStockTotal=k.reservedStockCopy + k.reservedStock
					if(k.parents !== null){
						if(k.parents.length){
							k.parents.forEach(j => {
								k.reservedStockCopy +=j.rate * j.reservedStock
								k.assibleUnshiped+=j.rate*j.unShipped
							})
							
						}
					}
				})
			}
		
		})
		state.userStormList=data.items
		state.newUserstoreItem=data.groups
		state.itemsCount =data.count
	},
	[SET_ITEMS_COUNT]: (state,data) => {
		data.forEach(p => {
			p.num=1
			p.anotherName=''
		})
		state.targetlist =data
		console.log('targetlist',state.targetlist)
		
	},
	[SET_BIND_ITEMS_LIST]:(state,data) => {
		state.bindItemList01=data
	},
	[REMOVE_ITEM]: (state,data) => {
		console.log(state.newUserstoreItem)

		for (var i = 0; i < state.newUserstoreItem.length; i++) {
			if (state.newUserstoreItem[i].cusCode === data.cusCode) {
			  state.newUserstoreItem.splice(i,1)
			  break;
			}    
		 }
		
	},
	[REMOVE_BIND_ITEM]: (state,data) => {
		for (var i = 0; i < state.bindItemList01.length; i++) {
		            if(state.bindItemList01.hasVariation) {
						if (data.itemId === state.bindItemList01[i].itemId && data.variation.variationId === state.bindItemList01[i].variation.variationId) {
						  state.bindItemList01.splice(i,1)
						  break;
						}
					}else{
						if (data.itemId === state.bindItemList01[i].itemId) {
						  state.bindItemList01.splice(i,1)
						  break;
						}
					}  
		 }
	},
	
	[TARGET_ALL]:(state,data) => {
		if(data) {
			state.userStormList.forEach(p => {
				p.checked=true
			})
		}else {
			state.userStormList.forEach(p => {
				p.checked=false
			})
		}
	},
	[GET_DATA_STATUS]: state => {
		state.getDateSuccess=true
	},
	[GET_DATA_STATUS_COLSE]: state => {
		state.ischooselist=[]
		console.log('JDKFMN',state.ischooselist)
		state.storeproductinventoryturnover=0
	},
	//设置补货周期
	[SET_REPLENISHMENT_PREIOD]:(state,data) => {
		new Promise((resolve) => {
			let arr=state.xuehuoInfo01
			console.log('补货周期',data)
			if(data.onway) {//扣减在途库存
				state.xuehuoInfo01.forEach(p => {
					p.dayOfShip=data.shipbyday
					let arr=state.xuehuoInfo01.filter(p => {
						 p.salesAvg01=Number(p.salesAvg.toFixed(2))  
						 p.needStock01=(p.dayOfShip*2*p.salesAvg01-p.nowStock-p.shippedStock).toFixed(0)
							return p
					})
					state.xuehuoInfo=arr
					
				})
			}else{//不扣减在途库存
				console.log(data.shipbyday)
				arr.forEach(p => {
					p.dayOfShip=data.shipbyday
					let arr=state.xuehuoInfo.filter(p => {
						 p.salesAvg01=Number(p.salesAvg.toFixed(2))  
						 p.needStock01=(p.dayOfShip*2*p.salesAvg01-p.nowStock).toFixed(0)
							return p
					})
					
					state.xuehuoInfo=arr
					
				})
			}
		})
		
	},
	[GET_UNSALABLE_DATA]:(state,data) => {
		let arr=state.slugInReminder.filter(p => {
			if(p.storeItem.storeId === data){
				return p
			}
		})

		state.unsalable=arr

		console.log('unsaleble',arr)

	},
	
	//获取的缺货的数据后，计算实际需要采购的数量
	[GET_QUENTITY_OUT_OF_STOCK]:(state,data) => {
		
		let arr=data.remindData.filter(p => {
				p.salesAvg01=Number(p.salesAvg.toFixed(2))
				p.needStock01=Number((p.dayOfShip*2*p.salesAvg01-p.nowStock).toFixed(0))
			   return p
			
		})

		console.log('改造后的数据',arr)
		state.slugInReminder=arr.filter(p => {
			if(p.unsalable){
				return p
			}
		})

		console.log('slugInReminder',state.slugInReminder)
		state.xuehuoInfo=arr
		state.xuehuoInfo01=arr
	},
	//当用户勾选扣减在途库存后，调用此方法
	[GET_QUENTITY_OUT_OF_STOCK_01]:(state,data) => {
		let arr=state.xuehuoInfo //保存一下原始数据
		console.log(127,state.xuehuoInfo)
		if(data) {
			console.log(122,arr)
			state.xuehuoInfo.forEach(p => {
				p.needStock01=Number(p.needStock01)-p.shippedStock
			})
			
		}else{
			console.log(555)
			state.xuehuoInfo.forEach(p => {
				p.needStock01=Number(p.needStock01)+p.shippedStock
			})
		}
	},
	[SET_COUNT_QUEHUO]:(state,data) => {
		state.xuehuoInfocount=data
		
	},
	//保存选中的货品
	[KEEP_CHOOSED_ITEM]:(state,data) => {
		state.ischooselist=data
		
	},



}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}